import React, { useRef, useEffect, useCallback } from 'react';
import { useReactToPrint } from 'react-to-print';
import ContractDocument from './ContractDocument';
import useGeneratePDF from '../CustomHooks/useGeneratePDF';

export default function GeneratePDF({ rowData, openPDF, onClose }) {
  const componentRef = useRef();
  const shouldPrintRef = useRef(false);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'Worrell Harvesting Contract',
    onAfterPrint: () => {
      console.log('✅ Print complete');
      shouldPrintRef.current = false;
      if (onClose) onClose();
    },
  });

  const handlePrintRef = useRef(handlePrint);
  useEffect(() => {
    handlePrintRef.current = handlePrint;
  }, [handlePrint]);

  // When openPDF becomes true, mark that we WANT to print
  useEffect(() => {
    if (openPDF) {
      shouldPrintRef.current = true;
    }
  }, [openPDF]);

  // This callback is called by useGeneratePDF when fresh data is ready
  const onDataReady = useCallback(() => {
    if (shouldPrintRef.current) {
      shouldPrintRef.current = false;
      // Small timeout to ensure React has re-rendered with new data
      setTimeout(() => {
        handlePrintRef.current();
      }, 100);
    }
  }, []);

  const { loading, siteInfoData, siteData, otherInfo, timberPricingData, accountingInfo } = useGeneratePDF(
    rowData?.current,
    onDataReady,
  );

  return (
    <div style={{ position: 'absolute', left: '-9999px', top: 0 }}>
      {(openPDF || shouldPrintRef.current) && (
        <ContractDocument
          ref={componentRef}
          rowDataCurrent={rowData}
          siteInfoData={siteInfoData}
          siteData={siteData}
          otherInfo={otherInfo}
          timberPricingData={timberPricingData}
          accountingInfo={accountingInfo}
        />
      )}
    </div>
  );
}
